const styles = (theme) => ({
  application: {
    position: 'relative',
    boxSizing: 'border-box',
  },
  folderWrapper: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#F8F9FC',
    height: 'calc(100vh - 235px)',
    minWidth: 0,
    minHeight: 0,
    overflow: 'hidden',
    '& [data-testid="tab-children"]': {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      overflow: 'hidden',
    },
    '& .MuiBox-root': {
      '& .MuiPaper-root': {
        padding: 0,
      },
    },
    '& > div > div > div > .Mui-selected': {
      '& svg': {
        fill: 'var(--blue-main)',
      },
    },
    '& > div > div > div': {
      '& svg': {
        marginRight: 5,
      },
    },
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      minHeight: 'calc(100vh - 235px)',
    },
  },
  tabPanel: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    height: '100%',
    minHeight: 0,
    minWidth: 0,
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
});

export default styles;
